import Headroom from 'headroom.js';
/* eslint-disable */
export class SiteHeader {
  constructor(element) {
    this.mobileMQ = window.matchMedia("(max-width: 1199px)");
    this.element = element;
    this.headerRoot = document.querySelector('.site-header');
    this.headroom = new Headroom(this.headerRoot, {
      tolerance: 0,
      offset: this.headerRoot.clientHeight
    });
    this.openButton = document.querySelector(`[aria-controls="${this.element.id}"]`);
    this.parentNavItems = this.element.querySelectorAll(".site-header__mega-menu-main-nav > ul > li");
    this.subNavs = this.element.querySelectorAll(".site-header__mega-menu-main-nav-subnav");
    this.subnavToggleLinks = this.element.querySelectorAll(".site-header__mega-menu-main-nav > ul > li > a, .site-header__mega-menu-main-nav > ul > li > button");
    // this.searchTrigger = AccessibilityUtilities.convertAnchorToButton(document.querySelector(".site-header__search-toggle"));
    this.searchTrigger = document.querySelector(".site-header__search-toggle");
    this.searchForm = document.querySelector(".site-header__search-form");
    this.formInput = document.querySelector(".site-header__search-form [name=s]");
    this.visible = false;
    this.searchVisible = false;
    this.selectedMainNavSectionIndex = null;
    this.mobileSubnavBackButtons = this.element.querySelectorAll(".site-header__mega-menu-main-nav-subnav-back");
    this.secondaryMenu = this.element.querySelector(".site-header__mega-menu-secondary");
    this.audienceMenuTrigger = document.querySelector(".site-header__audience-trigger");
    this.audienceMenu = document.querySelector(".site-header__top .site-header__audience-inner");
    this.audienceMenuVisible = false;
    this.skipLink = document.querySelector(".skip-link");
    this.mainPageContent = document.querySelector("main");
  }

  init() {
    this.handleResize();
    this.initialState();
    this.handleEsc();
    this.handleOpenButtonClick();
    this.handleTransitionEnd();
    this.handleSubnavToggleClicks();
    this.handleMobileSubnavBackButtons();
    this.handleOutsideClick();
    this.handleSearch();
    this.closeSearchEscape();
    this.closeSearchOutsideClick();
    this.searchTabPast();
    this.handleAudienceMenu();
    this.cloneUtilityMenu();
    this.disableTabbingWithinHiddenElements();
  }

  handleResize() {
    const resize = () => {
      this.handleStates();
      // this.initStickyNav();
    };
    this.mobileMQ.addEventListener("change", resize);
    resize();
  }

  initialState() {
    this.openButton.setAttribute("aria-expanded", "false");
    this.subNavs.forEach((subNav) => {
      subNav.setAttribute("aria-hidden", "true");
    });
  }

  handleStates() {
    // if desktop, hidden, not hamburger or hybrid variants
    if (
      !this.mobileMQ.matches &&
      !this.visible
    ) {
      this.element.setAttribute("aria-hidden", "false");
    } else if (
      this.mobileMQ.matches &&
      !this.visible
    ) {
      this.element.setAttribute("aria-hidden", "true");
    }

    // if hamburger is opened, it's desktop, not hamburger or hybrid variants
    if (
      !this.mobileMQ.matches &&
      this.visible
    ) {
      this.toggleHamburgerVisibility();
      this.element.setAttribute("aria-hidden", "false");
    }

    // if mobile and subnav is open - set to close
    this.subNavs.forEach((subNav) => {
      if (
        this.mobileMQ.matches &&
        !this.visible &&
        subNav.getAttribute("aria-hidden") === "false"
      ) {
        this.toggleSubnavSections(this.selectedMainNavSectionIndex, true, null);
        this.selectedMainNavSectionIndex = null;
      }
    });

    // if desktop, visible, set secondary menu to aria hidden false
    if (!this.mobileMQ.matches && this.visible) {
      this.secondaryMenu.setAttribute("aria-hidden", "false");
    }
  }

  toggleHamburgerVisibility() {
    // if search hamburger is closed and search is clicked
    if (!this.visible && this.searchVisible) {
      this.toggleSearch();
    }
    this.visible = !this.visible;
    this.openButton.setAttribute("aria-expanded", `${this.visible}`);
    this.element.setAttribute("aria-hidden", `${!this.visible}`);
    // this.secondaryMenu.setAttribute("aria-hidden", `${!this.visible}`);
    this.element.classList.add("transitioning");

    // update body classes (desktop only)
    if (!this.mobileMQ.matches) {
      this.visible
        ? document.body.classList.add("body--scroll-lock")
        : document.body.classList.remove("body--scroll-lock");
    } else {
      // Close Submenus on mobile when mobile menu closed
      this.visible ?
        null : 
        this.subNavs.forEach((el, i)=> {
          if(el.getAttribute('aria-hidden') === "false") {
            el.setAttribute('aria-hidden', 'true');
            el.parentElement.querySelector('.site-header__mega-menu-main-top-link').setAttribute('aria-expanded', 'false');
          }
        })
    }

    // update body classes
    this.visible
      ? this.mainPageContent.setAttribute("aria-hidden", "true")
      : this.mainPageContent.setAttribute("aria-hidden", "false");

    if (this.mobileMQ.matches) {
      this.bodyScrollLock(this.visible);
    }
    this.toggleClonedMenuAccess();
  }

  handleOpenButtonClick() {
    this.openButton.addEventListener("click", () => {
      this.toggleHamburgerVisibility();
    });
  }

  handleEsc() {
    document.addEventListener("keydown", (event) => {
      const key = event.key || event.keyCode;
      // Close the nav when the esc key is pressed while it's open
      if (key === "Escape" || key === "Esc" || key === 27) {
        if (this.visible) {
          this.toggleHamburgerVisibility();
        }
      }
    });
  }

  handleTransitionEnd() {
    this.element.addEventListener("transitionend", (event) => {
      if (event.target === event.currentTarget) {
        if (this.element.classList.contains("transitioning")) {
          this.element.classList.remove("transitioning");
        }
      }
    });
  }

  bodyScrollLock(visibility) {
    const htmlElement = document.documentElement;
    if (visibility) {
      const offsetY = window.scrollY;
      document.body.style.top = `${-offsetY}px`;
      document.body.classList.add("body--scroll-lock");
      htmlElement.style.scrollBehavior = "initial";
    } else {
      const offsetY = Math.abs(parseInt(document.body.style.top || "0", 10));
      document.body.classList.remove("body--scroll-lock");
      document.body.style.removeProperty("top");
      window.scrollTo(0, offsetY || 0);
      htmlElement.style.removeProperty("scroll-behavior");
    }
  }

  handleSubnavToggleClicks() {
    this.subnavToggleLinks.forEach(
      (parentNavItemLink, parentIndex) => {
        const correspondingSubnav =
          parentNavItemLink.nextElementSibling;
        if (!correspondingSubnav) return;

        // const parentNavItemLinkButton =
        //   AccessibilityUtilities.convertAnchorToButton(parentNavItemLink);
        const parentNavItemLinkButton = parentNavItemLink;
        parentNavItemLinkButton.setAttribute("aria-expanded", "false");

        parentNavItemLinkButton.addEventListener("click", (e) => {
          const target = e.currentTarget;
          // Close search if open
          if (this.searchVisible) {
            this.toggleSearch();
          }

          const isCurrentlyExpanded =
            parentNavItemLinkButton.getAttribute("aria-expanded") === "true";

          // Toggle subnav sections
          this.toggleSubnavSections(
            this.selectedMainNavSectionIndex,
            isCurrentlyExpanded,
            target
          );

          // Handle desktop - close menu on tabbing past last item
          if (!isCurrentlyExpanded && !this.mobileMQ.matches) {
            this.handleDesktopLastTabClose();
          }

          // Update selected index
          this.selectedMainNavSectionIndex = isCurrentlyExpanded
            ? null
            : parentIndex;
        });
      }
    );
  }

  handleMobileSubnavBackButtons() {
    this.mobileSubnavBackButtons.forEach((mobileSubnavBackButton) => {
      mobileSubnavBackButton.addEventListener("click", (e) => {
        const parentSubNav = mobileSubnavBackButton.closest(".site-header__mega-menu-main-nav-subnav");
        const parentNavItemLinkButton = parentSubNav.previousElementSibling;
        parentSubNav.setAttribute("aria-hidden", "true");
        parentNavItemLinkButton.setAttribute("aria-expanded", "false");
        this.selectedMainNavSectionIndex = null;
        this.openButton.focus();
        // this.secondaryMenu.setAttribute("aria-hidden", "false");
      });
    });
  }

  toggleSubnavSections(index, isCurrentlyVisible, target) {
    if (!target || !(target)) return;

    const navItems = Array.from(
      this.element.querySelectorAll(".site-header__mega-menu-main-top-link")
    );

    // Toggle subnav state
    const toggleSubnavState = (
      linkElement,
      subnavElement,
      shouldExpand
    ) => {
      linkElement.setAttribute("aria-expanded", `${shouldExpand}`);
      subnavElement.setAttribute("aria-hidden", `${!shouldExpand}`);
    };

    // When a subnav is currently open
    if (index !== null) {
      const currentParentItem = this.parentNavItems[index];
      const currentParentLink = currentParentItem.querySelector("button, a");
      const currentSubnav = currentParentItem.querySelector(".site-header__mega-menu-main-nav-subnav");

      if (!currentParentLink || !currentSubnav) return;

      // Toggle current subnav
      toggleSubnavState(currentParentLink, currentSubnav, !isCurrentlyVisible);

      // If a subnav was already open and another clicked
      if (
        target !== currentParentLink &&
        target.classList.contains("site-header__mega-menu-main-top-link")
      ) {
        const targetSubnav = (target).nextElementSibling;

        // Reset current subnav
        toggleSubnavState(currentParentLink, currentSubnav, false);

        // Toggle new subnav
        toggleSubnavState(target, targetSubnav, true);

        // Update selected index
        this.selectedMainNavSectionIndex = navItems.indexOf(target);
      }
    }
    // When no subnav is currently open
    else {
      // Ensure the target is a nav item
      if (target.classList.contains("site-header__mega-menu-main-top-link")) {
        const targetSubnav = (target).nextElementSibling;

        // Toggle target subnav
        toggleSubnavState(target, targetSubnav, true);

        // Update selected index
        this.selectedMainNavSectionIndex = navItems.indexOf(target);

        // Handle mobile secondary menu
        // if (this.mobileMQ.matches) {
        //   this.secondaryMenu.setAttribute(
        //     "aria-hidden",
        //     `${!isCurrentlyVisible}`
        //   );
        // }
      }
    }
  }

  handleOutsideClick() {
    document.body.addEventListener("click", (e) => {
      const target = e.target;
      const isClickInsideDropdown = Array.from(this.subNavs).some((container) =>
        container.contains(target)
      );

      if (
        !isClickInsideDropdown &&
        !target.closest(".site-header__mega-menu-main-top-link") &&
        !this.mobileMQ.matches
      ) {
        this.toggleSubnavSections(
          this.selectedMainNavSectionIndex,
          true,
          target
        );
        this.selectedMainNavSectionIndex = null;
      }
    });
  }

  handleDesktopLastTabClose() {
    // close the opened dropdown when the last item is selected and the tab key is pressed
    this.subNavs.forEach((subNav) => {
      if (!this.mobileMQ.matches && subNav.getAttribute("aria-hidden") === "false") {
        const lastDropdownLI = subNav.querySelector(
          "li:last-child"
        );
        const lastDropdownLink = lastDropdownLI.querySelector(
          ".site-header__mega-menu-main-sub-link"
        );
        lastDropdownLink.addEventListener("keydown", (event) => {
          const key = event.key || event.keyCode;
          if (event.key === "Tab" && !event.shiftKey) {
            // close the currently open dropdown
            this.toggleSubnavSections(
              this.selectedMainNavSectionIndex,
              true,
              event.target
            );
            this.selectedMainNavSectionIndex = null;
          }
        });
      }
    });
  }

  initStickyNav() {
    const siteHeaderRoot = document.querySelector(
      ".site-header"
    );
    // const emergencyAlert = document.querySelector(
    //   ".emergency-alert"
    // );
    setTimeout(() => {
      const siteHeader = document.querySelector(".site-header");
      const globalAlertHeight = siteHeader.clientHeight;
      this.headroom = new Headroom(siteHeaderRoot, {
        tolerance: 0,
        offset: globalAlertHeight,
      });
      this.headroom.init();
    }, 300);
  }

  toggleSearch() {
    if (this.visible && !this.searchVisible) {
      this.toggleHamburgerVisibility();
    }

    this.searchVisible = !this.searchVisible;
    this.searchVisible
      ? document.body.classList.add("body--scroll-lock-search")
      : document.body.classList.remove("body--scroll-lock-search");
    this.searchVisible
      ? this.searchTrigger.setAttribute("aria-expanded", "true")
      : this.searchTrigger.setAttribute("aria-expanded", "false");
    this.searchVisible
      ? this.searchForm.setAttribute("aria-hidden", "false")
      : this.searchForm.setAttribute("aria-hidden", "true");
    if (this.searchVisible) {
      setTimeout(() => {
        this.formInput.focus();
      }, 300);
    }

    this.bodyScrollLock(this.searchVisible);
  }

  handleSearch() {
    if (this.searchTrigger) {
      this.searchForm.setAttribute("aria-hidden", "true");
      this.searchTrigger.setAttribute("aria-expanded", "false");
      this.searchTrigger.addEventListener("click", () => {
        this.toggleSearch();
      });
    }
  }

  closeSearchEscape() {
    document.addEventListener("keydown", (event) => {
      const key = event.key || event.keyCode;
      if (key === "Escape" || key === "Esc" || key === 27) {
        if (this.searchVisible) {
          this.toggleSearch();
        }
      }
    });
  }

  searchTabPast() {
    const lastTabbableSearchItem = this.searchForm.querySelector(
      ".site-header__search-form-field-wrap button[type='submit']"
    );
    if (lastTabbableSearchItem) {
      lastTabbableSearchItem.addEventListener("keydown", (event) => {
        const key = event.key || event.keyCode;
        if (event.key === "Tab" && !event.shiftKey) {
          if (this.searchVisible) {
            this.toggleSearch();
          }
        }
      });
    }
  }

  closeSearchOutsideClick() {
    document.body.addEventListener("click", (event) => {
      const target = event.target;
      if (this.searchVisible && !target.closest(".site-header")) {
        this.toggleSearch();
      }
    });
  }

  handleAudienceMenu() {
    if (this.audienceMenu) {
      this.audienceMenuTrigger.setAttribute("aria-expanded", "false");
      const toggleAudienceMenu = () => {
        this.audienceMenuVisible = !this.audienceMenuVisible;
        // close if search clicked
        if (this.searchVisible && this.audienceMenuVisible) {
          this.toggleSearch();
        }
        this.audienceMenuVisible
          ? this.audienceMenu.setAttribute("aria-hidden", "false")
          : this.audienceMenu.setAttribute("aria-hidden", "true");
        this.audienceMenuVisible
          ? this.audienceMenuTrigger.setAttribute(
              "aria-expanded",
              "true"
            )
          : this.audienceMenuTrigger.setAttribute(
              "aria-expanded",
              "false"
            );
      };
      // add event listener to trigger
      this.audienceMenuTrigger.addEventListener("click", () => {
        toggleAudienceMenu();
      });
      // add event listener to escape key press
      document.addEventListener("keydown", (event) => {
        const key = event.key || event.keyCode;
        if (key === "Escape" || key === "Esc" || key === 27) {
          if (this.audienceMenuVisible) {
            toggleAudienceMenu();
          }
        }
      });
      // close after tabbing past last link
      const lastAudienceInnerLink = this.audienceMenu.querySelector(
        ".site-header__audience-inner ul li:last-child a"
      );
      lastAudienceInnerLink.addEventListener("keydown", (event) => {
        const key = event.key || event.keyCode;
        if (event.key === "Tab" && !event.shiftKey) {
          if (this.audienceMenuVisible) {
            toggleAudienceMenu();
          }
        }
      });
      // close on outside click
      document.body.addEventListener("click", (event) => {
        const target = event.target;
        if (this.audienceMenuVisible) {
          if (
            !target.closest(".site-header__audience-inner") &&
            !target.closest(".site-header__audience-trigger")
          ) {
            toggleAudienceMenu();
          }
        }
      });
    }
  }


  // Clones the Utility Menu for Mobile because it's honestly easier 
  // than trying to restructure the PL/Wordpress Integration

  cloneUtilityMenu() {
    const megaMenuMain = document.querySelector('.site-header__mega-menu-main-nav');
    const utilityMenu = document.querySelector('.site-header__ctas');
    const clonedUtilityMenu = utilityMenu.cloneNode(true);

    const megaMenuSecondary = document.createElement('div');
    megaMenuSecondary.classList.add('site-header__mega-menu-secondary');
    megaMenuSecondary.setAttribute('aria-hidden', 'false');

    megaMenuSecondary.appendChild(clonedUtilityMenu);
    megaMenuMain.appendChild(megaMenuSecondary);

    // Initialize Utility Menu.
    const menuTriggers = megaMenuSecondary.querySelectorAll(".site-header__audience-trigger");
    const dropdownMenus = megaMenuSecondary.querySelectorAll(".site-header__audience-inner");

    menuTriggers.forEach((el, i) => {
      el.remove();
    });

    dropdownMenus.forEach((el, i) => {
      el.removeAttribute("aria-hidden");
      el.removeAttribute("id");
      el.querySelector("noscript").remove();
    });
  }

  toggleClonedMenuAccess() {
    const utilityItems = this.element.querySelectorAll(".site-header__mega-menu-main-nav .site-header__mega-menu-secondary a");
    this.visible ? 
      utilityItems.forEach((el, i) => {
        el.removeAttribute('tabindex');
      }) :
      utilityItems.forEach((el, i) => {
        el.setAttribute('tabindex', '-1');
      }) 
  }


  disableTabbingWithinHiddenElements() {
    const userTabbing = false;
    const focusableChildSelector = `a[href], button, input, textarea, select, details, video, iframe, table, [tabindex]:not([tabindex="-1"]), [role='button'], .swiper-pagination .swiper-pagination-bullet`;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          ["aria-hidden", "hidden"].includes(mutation.attributeName) &&
          mutation.target.nodeType === Node.ELEMENT_NODE
        ) {
          const target = mutation.target;
          const isHidden =
            (mutation.attributeName === "hidden" &&
              target.hasAttribute("hidden")) ||
            (mutation.attributeName === "aria-hidden" &&
              target.getAttribute("aria-hidden") === "true");

          const focusableChildren = target.querySelectorAll(focusableChildSelector);

          focusableChildren.forEach((child) => {
            // Ensure changes apply only to direct descendants of the mutated target
            if (child.closest("[aria-hidden]") === target) {
              setTimeout(() => {
                child.tabIndex = isHidden ? -1 : 0;
              }, 100);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeOldValue: true,
    });
  }
}
